var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "div",
        { staticStyle: { position: "relative" }, attrs: { id: "Return_Bar" } },
        [
          _c("i", { staticClass: "el-icon-arrow-left" }),
          _vm._v(" "),
          _c("div", { staticClass: "isreturn", on: { click: _vm.isreturn } }, [
            _vm._v("返回")
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticStyle: {
                position: "absolute",
                top: "9px",
                right: "20px",
                "z-index": "9"
              },
              attrs: {
                target: "_blank",
                href:
                  _vm.imUrl +
                  "/TJ_TJK_IMAction.html?token=" +
                  _vm.imToken +
                  "&tjkId=" +
                  _vm.tjkInfo.id +
                  "&userName=" +
                  _vm.tjkInfo.realName +
                  "&tjkNumber=" +
                  _vm.tjkInfo.tjkNum +
                  "&platform=assitant"
              }
            },
            [
              _c("img", {
                staticStyle: { height: "30px" },
                attrs: { src: require("@/assets/images/zx.png"), alt: "" }
              })
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { attrs: { id: "text" } }, [
        _c(
          "iframe",
          {
            ref: "iframeQiannui",
            attrs: {
              id: "iframeQiannui",
              frameborder: "no",
              scrolling: "yes",
              allowfullscreen: "true",
              width: "100%",
              height: "100%",
              src: _vm.QiannuiiframeURL
            }
          },
          [
            _vm._v(
              "\n                您当前的浏览器不支持页面上的功能，请升级您当前的浏览器版本或使用谷歌浏览器访问当前页面\n            "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "提示", visible: _vm.currency, width: "360px" },
          on: {
            "update:visible": function($event) {
              _vm.currency = $event
            }
          }
        },
        [
          _c("div", { staticClass: "currency_img" }, [
            _c("img", {
              attrs: {
                src: require("../../../assets/images/voiceScene/currency_img.png"),
                alt: ""
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "currency_text" }, [
            _vm.tjkAnswer
              ? _c("div", { staticClass: "specialfont" }, [_vm._v("恭喜你!")])
              : _vm._e(),
            _vm._v(" "),
            _vm.tjkAnswer
              ? _c("div", { staticClass: "pecialfont-text" }, [
                  _vm._v("你已通过“"),
                  _c("span", { staticClass: "left_span" }, [
                    _vm._v("打字测试")
                  ]),
                  _vm._v("”")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.tjkAnswer
              ? _c("div", { staticClass: "specialfont-small" }, [
                  _vm._v("测试结果："),
                  _c("span", { staticClass: "left_span" }, [
                    _vm._v(_vm._s(_vm.speedfraction) + "字/分钟")
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.knowledgestate == 1
              ? _c("div", [
                  _vm._v("你已完成“"),
                  _c("span", { staticClass: "left_span" }, [
                    _vm._v(_vm._s(_vm.knowledgename))
                  ]),
                  _vm._v("”的学习"),
                  _c("br"),
                  _vm._v("接下来，请进行“"),
                  _c("span", { staticClass: "left_span" }, [
                    _vm._v(_vm._s(_vm.nextknowledgename))
                  ]),
                  _vm._v("”的学习")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.knowledgestate == 2 &&
            _vm.Coursestate == "Exam" &&
            _vm.tabstate == null
              ? _c("div", [
                  _vm._v("你已完成“"),
                  _c("span", { staticClass: "left_span" }, [
                    _vm._v(_vm._s(_vm.knowledgename))
                  ]),
                  _vm._v("”的" + _vm._s(_vm.nowCoursestatetext)),
                  _c("br"),
                  _vm._v("接下来，请进行一个测试")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.knowledgestate == 2 &&
            _vm.Coursestate == "Practice" &&
            _vm.tabstate == null
              ? _c("div", [
                  _vm._v("你已完成“"),
                  _c("span", { staticClass: "left_span" }, [
                    _vm._v(_vm._s(_vm.knowledgename))
                  ]),
                  _vm._v("”的" + _vm._s(_vm.nowCoursestatetext)),
                  _c("br"),
                  _vm._v("接下来，请进行下一个练习")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.knowledgestate == 2 &&
            _vm.Coursestate == "Study" &&
            _vm.tabstate == null
              ? _c("div", [
                  _vm._v("你已完成“"),
                  _c("span", { staticClass: "left_span" }, [
                    _vm._v(_vm._s(_vm.knowledgename))
                  ]),
                  _vm._v("”的" + _vm._s(_vm.nowCoursestatetext)),
                  _c("br"),
                  _vm._v("接下来，请进行下一个课程的学习")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.knowledgestate == 2 && _vm.tabstate == 2
              ? _c("div", [
                  _vm._v("你已完成“"),
                  _c("span", { staticClass: "left_span" }, [
                    _vm._v(_vm._s(_vm.categoryName))
                  ]),
                  _vm._v("”的学习"),
                  _c("br"),
                  _vm._v("接下来，请进行下一个阶段的学习")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.knowledgestate == 2 && _vm.tabstate == 1
              ? _c("div", [
                  _vm._v(
                    "你已完成" + _vm._s(_vm.categoryName) + "全部课程的学习"
                  ),
                  _c("br"),
                  _vm._v("现在可以去APP领取任务了")
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("div", { staticClass: "currency_button" }, [
                _vm.knowledgestate == 1 && _vm.Operation == false
                  ? _c(
                      "div",
                      {
                        staticClass: "determine",
                        on: { click: _vm.determine }
                      },
                      [_vm._v("\n                    去学习\n                ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.knowledgestate == 1 && _vm.Operation
                  ? _c(
                      "div",
                      {
                        staticClass: "determine",
                        on: { click: _vm.determine }
                      },
                      [_vm._v("\n                    去练习\n                ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.knowledgestate == 2 && _vm.Coursestate == "Exam"
                  ? _c(
                      "div",
                      {
                        staticClass: "determine",
                        on: { click: _vm.determine }
                      },
                      [_vm._v("\n                    去测试\n                ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.knowledgestate == 2 && _vm.Coursestate == "Study"
                  ? _c(
                      "div",
                      {
                        staticClass: "determine",
                        on: { click: _vm.determine }
                      },
                      [
                        _vm._v(
                          "\n                    继续学习\n                "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.knowledgestate == 2 && _vm.Coursestate == "Practice"
                  ? _c(
                      "div",
                      {
                        staticClass: "determine",
                        on: { click: _vm.determine }
                      },
                      [_vm._v("\n                    去练习\n                ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.knowledgestate == 2 &&
                _vm.tabstate == 2 &&
                _vm.dazhiJump == false
                  ? _c(
                      "div",
                      {
                        staticClass: "otherdetermine",
                        on: { click: _vm.determine }
                      },
                      [
                        _vm._v(
                          "\n                    去报名并参加" +
                            _vm._s(_vm.nextcategoryName) +
                            "\n                "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.knowledgestate == 2 && _vm.tabstate == 2 && _vm.dazhiJump
                  ? _c(
                      "div",
                      {
                        staticClass: "otherdetermine",
                        on: { click: _vm.determine }
                      },
                      [_vm._v("\n                    去学习\n                ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.knowledgestate == 2 && _vm.tabstate == 1
                  ? _c(
                      "div",
                      { staticClass: "determine", on: { click: _vm.goindex } },
                      [
                        _vm._v(
                          "\n                    我知道了\n                "
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73fea878", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73fea878","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/newservice/OnInline.vue
// module id = 1656
// module chunks = 0